import React, { FC } from "react";
import Loader from "../../../../../../common/loader/Loader";
import "./DocumentPreview.scss";
import useDocumentPreview from "../../../../../hooks/useDocumentPreview";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { Document } from "../../../../../../document";
import { PDF_MIME_TYPE } from "../../../../../../document/constants";
import { resolveMimeType } from "../../../../../../document/utils/mimeType";

type Props = {
  document: Document;
};

const DocumentPreview: FC<Props> = ({ document }) => {
  const { t } = useTranslation("overview");

  const { pdfFile, isError, isLoading } = useDocumentPreview(document.id);
  // The frame has to be told what it is showing; a PNG announced as a PDF renders as
  // the raw bytes. PDF stays the answer when nothing identifies the file.
  const mimeType = resolveMimeType(document) ?? PDF_MIME_TYPE;

  if (isLoading) {
    return (
      <div className="document-preview__container">
        <Loader size="default" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="document-preview__container">
        <Alert
          title={t("documentPreviewErrorAlert")}
          type="warning"
          showIcon
          className="error-alert"
        />
      </div>
    );
  }

  return (
    <iframe
      title="Preview"
      src={`data:${mimeType};base64,${pdfFile}#toolbar=0`}
      className="document-preview__container"
      loading="lazy"
    />
  );
};

export default DocumentPreview;
